@if (baseRules?.hasOutstanding && !isReviewPage) {
<h2 class="axis-h4">South Carolina</h2>
@if (reactiveForm) {
<form [formGroup]="reactiveForm">
      <div
        class="axis-form-group _mt-medium"
        [ngClass]="{
          'has-axis-required': reactiveForm.get(controls[1].formControlName)?.value === null,
          'has-axis-error':
            reactiveForm.get(controls[1].formControlName)?.touched &&
            reactiveForm.get(controls[1].formControlName)?.invalid,
        }"
      >
    @if (baseRules.UMLimits_Text === "show") {
    <label class="axis-control-label">
      {{ textValues?.UMLimits_Text }}
    </label>
    }
    @if (controls?.length >= 2) {
    <axis-radio-button-wrapper formControlName="{{ controls[1].formControlName }}">
      @for (control of controls[1].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[1].formControlName }}"
              ></axis-radio>
      }
    </axis-radio-button-wrapper>
    @if (reactiveForm.get(controls[1].formControlName)?.touched) {
    @if (reactiveForm.get(controls[1].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
    }
    }
    }
  </div>

  <div class="axis-grid">
    @for (control of controls | slice: 3 : 9; track $index) {
    @if (baseRules[control.baseRuleKey]?.includes("show") || baseRules[control.baseRuleKey]?.includes("form")) {
    <div class="axis-col-sm-6 axis-col-md-6">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required':
                    reactiveForm.get(control.formControlName)?.value === null ||
                    reactiveForm.get(control.formControlName)?.value === '',
                  'has-axis-error':
                    reactiveForm.get(control.formControlName)?.touched &&
                    reactiveForm.get(control.formControlName)?.invalid,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ control.formControlName }}"
                  >{{ control.label }}</label
                >
                <axis-dropdown
                  [dataProvider]="control.data"
                  id="{{ control.formControlName }}"
          formControlName="{{ control.formControlName }}"
                  (onSelect)="handleDropdownSelection(control, $event)"
                ></axis-dropdown>
        @if (reactiveForm.get(control.formControlName)?.touched) {
        @if (reactiveForm.get(control.formControlName)?.invalid) {
                    <span
                      class="axis-error-block"
                      role="alert"
                      >Please select an option.</span
                    >
        }
        }
        @if (control.selectedPremium) {
        <div [hidden]="!showPremium">Premium: {{ control.selectedPremium }}</div>
        }
      </div>
    </div>
    }
    }

    @if ((baseRules?.["UMSplitMinLimitsBI_DropDown"] || "").includes("readonly")) {
    <div class="axis-col-sm-6 axis-col-lg-4">
      <div class="axis-form-group">
        <label class="axis-control-label">{{ controls[6].label }}</label>
        <div id="umsplitlimitsbi_25k_50k-pdffield-south-carolina">
          {{ controls[6].data[0].name }}
        </div>
      </div>
    </div>
    }
    @if ((baseRules?.["UMSplitMinLimitsPD_DropDown"] || "").includes("readonly")) {
    <div class="axis-col-sm-6 axis-col-lg-4">
      <div class="axis-form-group">
        <label class="axis-control-label">{{ controls[7].label }}</label>
        <div id="umsplitlimitspd_25k-pdffield-south-carolina">
          {{ controls[7].data[0].name }}
        </div>
      </div>
    </div>
    }
    @if ((baseRules?.["UMCombinedMinSingleLimit_DropDown"] || "").includes("readonly")) {
    <div class="axis-col-sm-6 axis-col-lg-4">
      <div class="axis-form-group">
        <label class="axis-control-label">{{ controls[8].label }}</label>
        <div id="umcombinedsinglelimit_75k-pdffield-south-carolina">
          {{ controls[8].data[0].name }}
        </div>
      </div>
    </div>
    }
  </div>

      <div
        class="axis-form-group _mt-medium"
        [ngClass]="{
          'has-axis-required': reactiveForm.get(controls[0].formControlName)?.value === null,
          'has-axis-error':
            reactiveForm.get(controls[0].formControlName)?.touched &&
            reactiveForm.get(controls[0].formControlName)?.invalid,
        }"
      >
    @if (baseRules.UIMLimits_Text === "show") {
    <label class="axis-control-label">
      {{ textValues?.UIMLimits_Text }}
    </label>
    }
    @if (controls?.length >= 1) {
    <axis-radio-button-wrapper formControlName="{{ controls[0].formControlName }}">
      @for (control of controls[0].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[0].formControlName }}"
              ></axis-radio>
      }
    </axis-radio-button-wrapper>
    @if (reactiveForm.get(controls[0].formControlName)?.touched) {
    @if (reactiveForm.get(controls[0].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
    }
    }
    }
  </div>

      <div
        class="axis-form-group _mt-medium"
        [ngClass]="{
          'has-axis-required': reactiveForm.get(controls[2].formControlName)?.value === null,
          'has-axis-error':
            reactiveForm.get(controls[2].formControlName)?.touched &&
            reactiveForm.get(controls[2].formControlName)?.invalid,
        }"
      >
    @if (controls?.length >= 3) {
    <axis-radio-button-wrapper formControlName="{{ controls[2].formControlName }}">
      @for (control of controls[2].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[2].formControlName }}"
              ></axis-radio>
      }
    </axis-radio-button-wrapper>
    @if (reactiveForm.get(controls[2].formControlName)?.touched) {
    @if (reactiveForm.get(controls[2].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
    }
    }
    }
  </div>

  <div class="axis-grid">
     @for (control of controls | slice: 9; track $index) {
        @if (baseRules[control.baseRuleKey]?.includes("show") || baseRules[control.baseRuleKey]?.includes("form")) {
          <div class="axis-col-sm-6 axis-col-md-6">
            <div
              class="axis-form-group"
              [ngClass]="{
                'has-axis-required':
                  reactiveForm.get(control.formControlName)?.value === null ||
                  reactiveForm.get(control.formControlName)?.value === '',
                'has-axis-error':
                  reactiveForm.get(control.formControlName)?.touched &&
                  reactiveForm.get(control.formControlName)?.invalid,
              }">
              <label
                class="axis-control-label"
                for="{{ control.formControlName }}"
                >{{ control.label }}
              </label>
              <axis-dropdown
                [dataProvider]="control.data"
                id="{{ control.formControlName }}"
                formControlName="{{ control.formControlName }}"
                (onSelect)="handleDropdownSelection(control, $event)"
              ></axis-dropdown>
              @if (reactiveForm.get(control.formControlName)?.touched) {
                @if (reactiveForm.get(control.formControlName)?.invalid) {
                  <span
                    class="axis-error-block"
                    role="alert"
                    >Please select an option.</span
                  >
                }
              }
              @if (control.selectedPremium) {
                <div [hidden]="!showPremium">Premium: {{ control.selectedPremium }}</div>
              }
            </div>
          </div>
        }
      }

    @if ((baseRules?.["UIMSplitMinLimitsBI_DropDown"] || "").includes("readonly")) {
    <div class="axis-col-sm-6 axis-col-lg-4">
      <div class="axis-form-group">
        <label class="axis-control-label">{{ controls[12].label }}</label>
        <div id="uimsplitminlimitsbi_25k_50k-pdffield-south-carolina">
          {{ controls[12].data[0].name }}
        </div>
      </div>
    </div>
    }

    @if ((baseRules?.["UIMSplitMinLimitsPD_DropDown"] || "").includes("readonly")) {
    <div class="axis-col-sm-6 axis-col-lg-4">
      <div class="axis-form-group">
        <label class="axis-control-label">{{ controls[13].label }}</label>
        <div id="uimsplitminlimitspd_25k-pdffield-south-carolina">
          {{ controls[13].data[0].name }}
        </div>
      </div>
    </div>
    }

    @if ((baseRules?.["UIMCombinedSingleMinLimit_DropDown"] || "").includes("readonly")) {
    <div class="axis-col-sm-6 axis-col-lg-4">
      <div class="axis-form-group">
        <label class="axis-control-label">{{ controls[14].label }}</label>
        <div id="uimcombinedsingleminlimit_75k-pdffield-south-carolina">
          {{ controls[14].data[0].name }}
        </div>
      </div>
    </div>
    }
  </div>

  <!-- Readonly Reject -->
  @if (baseRules?.Reject_LevelOneUIM_Radio?.includes("Yes")) {
  <div class="axis-form-group">
          <label
            id="reject_leveloneuim_radio-pdffield-south-carolina"
            class="axis-control-label"
          >
      {{ textValues?.RejectUIM_Text }}
    </label>
  </div>
  }
</form>
}
}

@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
<h2 class="axis-h4">South Carolina</h2>

<div class="axis-grid">
  @if (baseRules?.UMSplitMinLimitsBI_DropDown) {
  <div class="axis-col-sm-6 axis-col-lg-4">
    <div class="axis-form-group">
      <label class="axis-control-label"> {{ controls[6].label }} </label>
      <div>{{ controls[6].data[0].name }}</div>
      <div [hidden]="!showPremium">Premium: {{ controls[6].data[0].premium }}</div>
    </div>
  </div>
  }
  @if (baseRules?.UMSplitMinLimitsPD_DropDown) {
  <div class="axis-col-sm-6 axis-col-lg-4">
    <div class="axis-form-group">
      <label class="axis-control-label"> {{ controls[7].label }} </label>
      <div>{{ controls[7].data[0].name }}</div>
      <div [hidden]="!showPremium">Premium: {{ controls[7].data[0].premium }}</div>
    </div>
  </div>
  }
  @if (baseRules?.UMCombinedMinSingleLimit_DropDown) {
  <div class="axis-col-sm-6 axis-col-lg-4">
    <div class="axis-form-group">
      <label class="axis-control-label"> {{ controls[8].label }} </label>
      <div>{{ controls[8].data[0].name }}</div>
      <div [hidden]="!showPremium">Premium: {{ controls[8].data[0].premium }}</div>
    </div>
  </div>
  }
  @if (baseRules?.UM_LiabilityLimit_DropDown) {
    <div class="axis-col-sm-6 axis-col-lg-4">
      <div class="axis-form-group">
        <label class="axis-control-label"> {{ controls[15].label }} </label>
        <div>{{ controls[15].data[0].name }}</div>
      </div>
    </div>
  }
</div>
@if (baseRules?.Reject_LevelOneUIM_Radio) {
<div class="axis-form-group">
  <label class="axis-control-label">
    {{ textValues?.RejectUIM_Text }}
  </label>
</div>
}

<div class="axis-grid">
  @if (baseRules?.UIMSplitMinLimitsBI_DropDown) {
  <div class="axis-col-sm-6 axis-col-lg-4">
    <div class="axis-form-group">
      <label class="axis-control-label"> {{ controls[12].label }} </label>
      <div>{{ controls[12].data[0].name }}</div>
      <div [hidden]="!showPremium">Premium: {{ controls[12].data[0].premium }}</div>
    </div>
  </div>
  }
  @if (baseRules?.UIMSplitMinLimitsPD_DropDown) {
  <div class="axis-col-sm-6 axis-col-lg-4">
    <div class="axis-form-group">
      <label class="axis-control-label"> {{ controls[13].label }} </label>
      <div>{{ controls[13].data[0].name }}</div>
      <div [hidden]="!showPremium">Premium: {{ controls[13].data[0].premium }}</div>
    </div>
  </div>
  }
  @if (baseRules?.UIMCombinedSingleMinLimit_DropDown) {
  <div class="axis-col-sm-6 axis-col-lg-4">
    <div class="axis-form-group">
      <label class="axis-control-label"> {{ controls[14].label }} </label>
      <div>{{ controls[14].data[0].name }}</div>
      <div [hidden]="!showPremium">Premium: {{ controls[14].data[0].premium }}</div>
    </div>
  </div>
  }
  @if (baseRules?.UIM_LiabilityLimit_DropDown) {
    <div class="axis-col-sm-6 axis-col-lg-4">
      <div class="axis-form-group">
        <label class="axis-control-label"> {{ controls[16].label }} </label>
        <div>{{ controls[16].data[0].name }}</div>
      </div>
    </div>
  }
</div>
}
